const CANONICAL_HOST = "www.einsured.ca";

// scripts/prerender.mjs bakes the static HTML snapshot (the one non-JS
// crawlers see) by visiting the app on 127.0.0.1 — and that exact same
// static build then gets deployed byte-identical to production AND every
// staging host. So the *baked* HTML must be treated as production here,
// otherwise prerendering would ship noindex/no-schema on production itself.
//
// This means the noindex/schema gating driven by this check only protects
// real browsers and JS-executing crawlers on an actual non-production host
// (staging.einsured.ca, preview hosts, etc.) — it can't differ between what
// ships in the static files for production vs. staging, since that file is
// identical everywhere. Blocking staging for good requires a server-level
// fix (X-Robots-Tag header / robots.txt / password-protecting the host) on
// each staging environment.
const PRERENDER_HOSTS = new Set(["127.0.0.1", "localhost", "::1"]);

export function isProductionHost() {
  if (typeof window === "undefined") return true;
  const host = window.location.hostname;
  if (PRERENDER_HOSTS.has(host)) return true;
  return host === CANONICAL_HOST;
}
